import RandingStyle20 from "../../randing/RandingStyle20";

function Randing220({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle20
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="3"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/220/1-1.png`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/220/2-1.png`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/220/3-1.png`}
      qOptionColor="blue"
      qTitleColor="#204cec"
      formFieldColor="white"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton2.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
      randingNumber="220"
    />
  );
}

export default Randing220;
